import { Card, CardContent } from '@/components/ui/card';

/**
 * Card wrapper for a horizontally-scrollable data table. Replaces the
 * `Card > CardContent p-0 overflow-x-auto > table` shell duplicated by the
 * Users and AuditLogs pages.
 */
const DataTableCard = ({ children, testId }) => (
  <Card data-testid={testId}>
    <CardContent className="p-0 overflow-x-auto">{children}</CardContent>
  </Card>
);

export default DataTableCard;
